import { useState } from 'react';
import { IconSignOut } from '../components/icons';
import { Avatar, Note, PageHead, Switch, ThemeSwitch } from '../components/ui';
import { setSosSound, useSosSound } from '../lib/sosSound';
import { api, errorMessage } from '../lib/api';
import { useAuth } from '../lib/auth';
import { session } from '../lib/session';

export function AccountPage() {
  const { admin, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const sound = useSosSound();
  return (
    <div className="stack" style={{ maxWidth: 680 }}>
      <PageHead title="Your account" />
      <section className="card card-pad">
        <div className="person">
          <Avatar name={admin?.name} large />
          <div style={{ minWidth: 0 }}>
            <div className="strong" style={{ fontSize: 18 }}>
              {admin?.name}
            </div>
            <div className="muted small truncate">
              {admin?.email} · {admin?.role === 'OWNER' ? 'Owner, full control' : 'Admin, runs the day'}
            </div>
          </div>
        </div>
      </section>
      <section className="card">
        <div className="card-head">
          <h2>On this device</h2>
        </div>
        <div className="card-body stack-sm" style={{ gap: 18 }}>
          <div className="spread">
            <div>
              <div className="strong">Appearance</div>
              <div className="small muted">Auto follows your device’s light or dark setting.</div>
            </div>
            <ThemeSwitch />
          </div>
          <div className="spread" style={{ flexWrap: 'nowrap' }}>
            <div>
              <div className="strong">SOS sound</div>
              <div className="small muted">A short chime when a new SOS arrives. The red strip shows either way.</div>
            </div>
            <Switch checked={sound} onChange={setSosSound} label="SOS sound" />
          </div>
          <div className="small muted">
            Keys on a computer: <kbd>/</kbd> search · <kbd>j</kbd> <kbd>k</kbd> move through a list · <kbd>Enter</kbd> open · <kbd>Esc</kbd> close
          </div>
        </div>
      </section>
      <form
        className="card card-pad stack-sm"
        style={{ gap: 16 }}
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await api.post('/admin/me/password', { currentPassword: current, newPassword: next });
            session.set(null);
          } catch (err) {
            setError(errorMessage(err));
            setBusy(false);
          }
        }}
      >
        <h2>Change password</h2>
        <label className="field">
          <span className="field-label">Current password</span>
          <input className="input" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} />
        </label>
        <label className="field">
          <span className="field-label">New password</span>
          <input className="input" type="password" autoComplete="new-password" required minLength={10} value={next} onChange={(e) => setNext(e.target.value)} />
          <span className="field-hint">At least 10 characters with a letter and a number. You’ll be signed out everywhere.</span>
        </label>
        {error && <Note tone="bad">{error}</Note>}
        <div className="row">
          <button className="btn btn-dark" disabled={busy}>
            {busy ? 'Saving…' : 'Change password'}
          </button>
        </div>
      </form>
      <section className="card card-pad spread">
        <div>
          <h3>Sign out</h3>
          <p className="small muted">Ends this session on this device.</p>
        </div>
        <button className="btn" onClick={() => void logout()}>
          <IconSignOut /> Sign out
        </button>
      </section>
    </div>
  );
}
